import { IonContent, IonGrid, IonPage, IonRow } from '@ionic/react';

import Cart from '../../components/cart/Cart';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import Products from './Shop/Products';

interface Props {
  products: []
}

const Tab2: React.FC<Props> = (props) => {
  return <IonPage className="tab-content">
    <Toolbar title="فروشگاه">
      <Cart />
    </Toolbar>

    <LayoutGap />

    <IonContent class="main-content">
      <IonRow>
        <Products items={props.products} />
      </IonRow>
    </IonContent>
  </IonPage>
}

export default Tab2;
